import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Fade from "react-reveal/Fade";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useFieldArray, useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import {
  capitalizeFirstLetter,
  checkNull,
  removeUnderScore,
} from "../../../helpers";
import { getSetupDetails, saveSetupWizardForm } from "../../../Redux/actions";
import SWInterface from "../../Components/Layout/SWInterface";
import BtmButtons from "../../Components/BtmButtons";

const numMsg = "Must be a valid number";
const reqMsg = "This field is required";
const schema = yup
  .object({
    users: yup.array().of(
      yup.object().shape({
        emp_groups: yup.string().required(reqMsg),
        emp_ids: yup.string().nullable(),
        user_ids: yup.string().required(reqMsg),
        emp_emails: yup.string().required(reqMsg),
        emp_ms: yup.string().required(reqMsg),
      })
    ),
  })
  .required();

const SetupWizardEight = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { account, merchant_users, user_groups, posPlans } = useSelector(
    (state) => state.authReducer.setup_wizard_details
  );

  const initialForm = {
    users: [],
  };
  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
    setValue,
    reset,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: initialForm,
    mode: "all",
    reValidateMode: "onChange",
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "users",
  });

  const [inputForm, setInputForm] = useState(initialForm);
  const isLogoutRef = useRef(false);
  const submitBtnRef = useRef(null);

  const changeInputHandler = (index, input, val) => {
    setValue(`users.${index}.${input}`, val);
    inputForm.users[index][input] = val;
    setInputForm({ ...inputForm });
  };

  const getErrorContainer = (index, type) => {
    return (
      <Fade
        right
        collapse
        when={
          errors && errors?.finance_account?.[index]?.[type]?.message
            ? true
            : false
        }
      >
        <label className="error">
          {errors?.finance_account?.[index]?.[type]?.message
            ? removeUnderScore(
                errors?.finance_account?.[index]?.[type]?.message
              )
            : ""}
        </label>
      </Fade>
    );
  };

  useEffect(() => {
    dispatch(getSetupDetails(7));
  }, []);
  useEffect(() => {
    if (merchant_users && merchant_users.length > 0) {
      const addUsersObj = [];
      merchant_users
        .filter((p) => p.group_id !== null)
        .map((child_user, i) => {
          console.log("child_user", child_user);
          const appendingData = {
            emp_groups: child_user?.group?.id ? `${child_user?.group?.id}` : "",
            emp_ids: child_user?.employee_id
              ? `${child_user?.employee_id}`
              : "",
            user_ids: child_user?.id ? `${child_user?.id}` : "",
            emp_emails: child_user?.email ? `${child_user?.email}` : "",
            emp_ms: child_user?.merchant_id ? `${child_user?.merchant_id}` : "",
          };
          append(appendingData);
          addUsersObj.push(appendingData);
        });
      setInputForm({ users: addUsersObj });
      reset({ users: addUsersObj });
    }
  }, [merchant_users]);

  const getCurrentPlanDetail = () => {
    let res = null;
    const merchantPurchPlanCount = parseInt(
      account?.merchant?.merchant_purchased_plan?.additional_users ?? 0
    );
    if (posPlans && posPlans.length > 0) {
      posPlans.map((pp, ppI) => {
        if (pp?.pos_plan_costs && pp?.pos_plan_costs.length > 0) {
          const ppcIndex = pp?.pos_plan_costs.findIndex(
            (p) => p.id == account?.merchant?.pos_plan_cost_id
          );
          console.log(
            "pos_plan_cost",
            ppcIndex,
            account?.merchant?.pos_plan_cost_id
          );
          if (ppcIndex > -1) {
            res = (
              <>
                {`${pp?.name} ${capitalizeFirstLetter(
                  pp?.[ppcIndex]?.type ?? ""
                )}`}
                {`${
                  merchantPurchPlanCount > 0
                    ? " + " + merchantPurchPlanCount + " Employees"
                    : ""
                }`}
              </>
            );
          }
        }
      });
    }
    return res;
  };

  const submitForm = (data) => {
    data?.users.map((input) => {
      if (input.emp_ids == "") input.emp_ids = null;
    });
    console.log("submitForm", data);
    dispatch(saveSetupWizardForm("seven", data, isLogoutRef?.current));
  };

  const submitNextHandler = (isLogoutType = false) => {
    isLogoutRef.current = isLogoutType;
    if (submitBtnRef !== null) {
      submitBtnRef.current.click();
    }
  };

  return (
    <SWInterface step={7}>
      {console.log("errors", errors)}
      {console.log("inputForms", inputForm)}
      <div className="steps-content">
        <div className="steps-div_outer">
          <form id="form_step_seven" onSubmit={handleSubmit(submitForm)}>
            <div className="account_setup row_count2" id="step7">
              <h4 className="event-alert mb-0"> User Account Setup </h4>
              <p className="mt0">Who’s going to be using this system? </p>
              <div className="row-fluid pt-2">
                <div className="col-8">
                  <ul className="ingredient-info edit-shift">
                    <li>
                      <label className="">Current Plan </label>
                      <div className="input-group span7">
                        {getCurrentPlanDetail()}
                      </div>
                    </li>
                    <li>
                      <label className=""> Add Ons </label>
                      <div className="input-group span7">NA </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="row-fluid general-setting labor_pol_tbl merchant_acc">
                <div className="span12 chart_acc_td newForm_sec">
                  <h3 className="event-alert mb-0">User List</h3>
                  <div className="inner-space screen-scroll mCS_destroyed">
                    <table
                      width="100%"
                      cellspacing="0"
                      cellpadding="0"
                      style={{ marginBottom: "0 !important" }}
                      className="checklist-table remove-space inventory_table"
                    >
                      <thead>
                        <tr>
                          <th width="">Username</th>
                          <th width="">Permission Group </th>
                          <th width="">Email</th>
                        </tr>
                      </thead>
                      <tbody>
                        {merchant_users && merchant_users.length > 0 ? (
                          merchant_users
                            .filter((p) => p.group_id !== null)
                            .map((child_user, i) => {
                              console.log("child_user", child_user);
                              return (
                                <tr>
                                  <td className="invent-first-col custom_row ">
                                    {child_user?.full_name ?? ""}
                                  </td>
                                  <td>
                                    <div className="input-group select-div span9">
                                      {child_user?.group?.id == 1 ? (
                                        <select
                                          // name="emp_groups[]"
                                          className="pergroup valid"
                                          {...register(`users.${i}.emp_groups`)}
                                          onChange={(event) =>
                                            changeInputHandler(
                                              i,
                                              "emp_groups",
                                              event?.target?.value
                                            )
                                          }
                                          value={
                                            inputForm?.users?.[i]?.emp_groups
                                          }
                                        >
                                          <option value="1">
                                            {child_user?.group?.name}
                                          </option>
                                        </select>
                                      ) : (
                                        <select
                                          // name="emp_groups[]"
                                          class="pergroup"
                                          {...register(`users.${i}.emp_groups`)}
                                          onChange={(event) =>
                                            changeInputHandler(
                                              i,
                                              "emp_groups",
                                              event?.target?.value
                                            )
                                          }
                                          value={
                                            inputForm?.users?.[i]?.emp_groups
                                          }
                                        >
                                          {user_groups &&
                                            user_groups.length > 0 &&
                                            user_groups.map((ug, ugI) => {
                                              return (
                                                <option value={ug?.id}>
                                                  {ug?.name}
                                                </option>
                                              );
                                            })}
                                        </select>
                                      )}
                                      {getErrorContainer(i, "emp_groups")}
                                    </div>
                                    <input
                                      type="hidden"
                                      // name="emp_ids[]"
                                      {...register(`users.${i}.emp_ids`)}
                                      value={inputForm?.users?.[i]?.emp_ids}
                                    />
                                    {getErrorContainer(i, "emp_ids")}
                                    <input
                                      type="hidden"
                                      // name="user_ids[]"
                                      {...register(`users.${i}.user_ids`)}
                                      value={inputForm?.users?.[i]?.user_ids}
                                    />
                                    {getErrorContainer(i, "user_ids")}
                                    <input
                                      type="hidden"
                                      // name="emp_emails[]"
                                      {...register(`users.${i}.emp_emails`)}
                                      value={inputForm?.users?.[i]?.emp_emails}
                                    />
                                    {getErrorContainer(i, "emp_emails")}
                                    <input
                                      type="hidden"
                                      // name="emp_ms[]"
                                      {...register(`users.${i}.emp_ms`)}
                                      value={inputForm?.users?.[i]?.emp_ms}
                                    />
                                    {getErrorContainer(i, "emp_ms")}
                                  </td>
                                  <td>{child_user?.email ?? ""}</td>
                                  <td></td>
                                </tr>
                              );
                            })
                        ) : (
                          <tr>
                            <td colspan="3" align="center">
                              No user found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <button
                type="submit"
                style={{ display: "none" }}
                ref={submitBtnRef}
              >
                Submit
              </button>
              <BtmButtons submitHandler={submitNextHandler} />
            </div>
          </form>
        </div>
      </div>
    </SWInterface>
  );
};
export default SetupWizardEight;
